import Street from "../Street/StreetForAdd";
import FileAndDocumentUploader from "./FileAndDocumentUploader";
//import File from "./file"
//import DocumnetFile from "./documentFile";
import More from "./More";
import AplicationStatus from "./AplicationStatus";
import { useState } from "react";
export default function Otherinfo({
  commercial,
  editData,
  files,
  handleFileChange,
  removeFile,
  handleDocumentFileChange,
  removeDocumentFile,
  house,
  land,
  errors,
  district,
  district1,
  district2,
  setFiles,
  setDocumentFiles,
  documentFiles,
  status,
  setStatus,
  percent, 
  setPercent
}) {
  const [isSmall1] = useState(window.innerWidth <= 650);
  return (
    <div className="addictionalInfo">
      <div className="newinformationformend">
        <div className="neeext">
          <div className="inputsection">
            <Street
              district={district}
              district1={district1}
	      district2={district2}
              editData={editData}
              errors={errors}
            />

            {land && (
              <input
                type="text"
                placeholder="ՀՈՂԱՏԱՐԱԾՔԻ ՀԱՍՑԵ"
                name="land_number"
                defaultValue={editData?.land_number}
                style={{
                  borderRadius: "10px",
                  border: errors?.land_number
                    ? "2px solid red"
                    : "1px solid #ccc",
                }}
              />
            )}

            {!land && (
              <input
                type="text"
                placeholder="ՇԻՆՈՒԹՅԱՆ ՀԱՍՑԵ"
                name="building_number"
                defaultValue={editData?.building_number}
                style={{
                  borderRadius: "10px",
                  border: errors?.building_number
                    ? "2px solid red"
                    : "1px solid #ccc",
                }}
              />
            )}
            {!house && !land && (
              <input
                type="text"
                placeholder="ԲՆԱԿԱՐԱՆԻ ՀԱՄԱՐԸ"
                name="room_number"
                defaultValue={editData?.room_number}
                style={{
                  borderRadius: "10px",
                  border: errors?.room_number
                    ? "2px solid red"
                    : "1px solid #ccc",
                }}
              />
            )}
          </div>
          {isSmall1 && (
            <div className="inputp">
              <div className="inputparamhelp">
                {!land && !house && <p>ՀԱՐԿ</p>}
                {house && <p>Հողատարածք(մ²)</p>}
                {!land && <p>Շինության հարկը</p>}
                <p>ԳՈՒՅՔԻ ՄԱԿԵՐԵՍ(Մ²)</p>
                <p>ԳԻՆ$</p>
              </div>
              <div className="inputparam">
                {!land && !house && !commercial && (
                  <input
                    style={{
                      borderRadius: "10px",
                      border: errors?.floor
                        ? "2px solid red"
                        : "1px solid #ccc",
                    }}
                    type="number"
                    name="a_floor"
                    defaultValue={editData?.a_floor}
                  />
                )}
                {commercial && (
                  <input
                    style={{
                      borderRadius: "10px",
                      border: errors?.floor
                        ? "2px solid red"
                        : "1px solid #ccc",
                    }}
                    type="number"
                    name="c_floor"
                    defaultValue={editData?.c_floor}
                  />
                )}

                {house && (
                  <input
                    style={{
                      borderRadius: "10px",
                      border: errors?.land_surface
                        ? "2px solid red"
                        : "1px solid #ccc",
                    }}
                    type="number"
                    name="land_surface"
                    defaultValue={editData?.land_surface}
                  />
                )}
                {!land && (
                  <input
                    style={{
                      borderRadius: "10px",
                      border: errors?.building_floor
                        ? "2px solid red"
                        : "1px solid #ccc",
                    }}
                    type="number"
                    name="building_floor"
                    defaultValue={editData?.building_floor}
                  />
                )}
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.sqm ? "2px solid red" : "1px solid #ccc",
                  }}
                  type="number"
                  name="surface"
                  defaultValue={editData?.surface}
                />
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.price ? "2px solid red" : "1px solid #ccc",
                  }}
                  type="number"
                  name="price"
                  defaultValue={editData?.price}
                />
              </div>
            </div>
          )}
          {!isSmall1 && (
            <div className="inputparamhelp">
              {!land && !house && <p>ՀԱՐԿ</p>}
              {house && <p>Հողատարածք(մ²)</p>}
              {!land && <p>Շինության հարկը</p>}
              <p>ԳՈՒՅՔԻ ՄԱԿԵՐԵՍ(Մ²)</p>
              <p>ԳԻՆ$</p>
            </div>
          )}
          {!isSmall1 && (
            <div className="inputparam">
              {!land && !house && !commercial && (
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.floor ? "2px solid red" : "1px solid #ccc",
                  }}
                  type="number"
                  name="a_floor"
                  defaultValue={editData?.a_floor}
                />
              )}
              {commercial && (
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.floor ? "2px solid red" : "1px solid #ccc",
                  }}
                  type="number"
                  name="c_floor"
                  defaultValue={editData?.c_floor}
                />
              )}

              {house && (
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.land_surface
                      ? "2px solid red"
                      : "1px solid #ccc",
                  }}
                  type="number"
                  name="land_surface"
                  defaultValue={editData?.land_surface}
                />
              )}
              {!land && (
                <input
                  style={{
                    borderRadius: "10px",
                    border: errors?.building_floor
                      ? "2px solid red"
                      : "1px solid #ccc",
                  }}
                  type="number"
                  name="building_floor"
                  defaultValue={editData?.building_floor}
                />
              )}
              <input
                style={{
                  borderRadius: "10px",
                  border: errors?.sqm ? "2px solid red" : "1px solid #ccc",
                }}
                type="number"
                name="surface"
                defaultValue={editData?.surface}
              />
              <input
                style={{
                  borderRadius: "10px",
                  border: errors?.price ? "2px solid red" : "1px solid #ccc",
                }}
                type="number"
                name="price"
                defaultValue={editData?.price}
              />
            </div>
          )}
          {commercial && (
            <div
              className="commercialType"
              style={{
                borderRadius: "10px",
                border: errors?.commercial_type
                  ? "2px solid red"
                  : "1px solid #ccc",
              }}
            >
              <div>
                <input
                  defaultChecked={editData?.commercial_type === true}
                  type="radio"
                  name="commercial_type"
                  value="true"
                />
                <label>Շինության Ներսում</label>
              </div>
              <div>
                <input
                  defaultChecked={editData?.commercial_type === false}
                  type="radio"
                  name="commercial_type"
                  value="false"
                />
                <label>Առանձին Շինության</label>
              </div>
            </div>
          )}
        </div>
        <div className="theEndPoint">
          <More editData={editData} />
          <textarea
            type="text"
            style={{
              borderRadius: "10px",
              border: errors?.discription ? "2px solid red" : "1px solid #ccc",
            }}
            name="discription"
            minLength={100}
            defaultValue={editData?.discription}
            placeholder="ՄՈՒՏՔԱԳՐԵՔ ԳՈՒՅՔԻ ՆԿԱՐԱԳՐՈՒԹՅՈՒՆԸ (ՆՎԱԶԱԳՈՒՅՆԸ 100 Տառ)"
          />
          <textarea
            type="text"
            name="secret_discription"
            placeholder="ՄՈՒՏՔԱԳՐԵՔ ԳԱՂՏՆԻ ԻՆՖՈՐՄԱՑԻԱՆ ԳՈՒՅՔԻ ՎԵՐԱԲԵՐՅԱԼ"
            defaultValue={editData?.secret_discription}
          />

          <div className="submitAdd">
            <AplicationStatus 
	  	editData={editData}  
	  	status={status}
		setStatus={setStatus}
	  	percent={percent}
	  	setPercent={setPercent}
	  />
          </div>
        </div>
      </div>
      
	  <FileAndDocumentUploader
        editData={editData}
        files={files}
        setFiles={setFiles}
        handleFileChange={handleFileChange}
        removeFile={removeFile}
        documentFiles={documentFiles}
        setDocumentFiles={setDocumentFiles}
        handleDocumentFileChange={handleDocumentFileChange}
        removeDocumentFile={removeDocumentFile}
      />
    </div>
  );
}
